import React from 'react';

import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import TabIcon from '@mui/icons-material/Tab';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';

import useSectionNavigationPreference, { SECTION_NAVIGATION_MODES } from '~/hooks/useSectionNavigationPreference';

interface SectionNavigationMenuItemProps {
  onClick?: () => void;
}

export default function SectionNavigationMenuItem({ onClick }: SectionNavigationMenuItemProps) {
  const [sectionNavigationMode, setSectionNavigationMode] = useSectionNavigationPreference();
  const isSwitchingToSidebar = sectionNavigationMode === SECTION_NAVIGATION_MODES.HEADER;

  const handleClick = () => {
    setSectionNavigationMode(isSwitchingToSidebar ? SECTION_NAVIGATION_MODES.SIDEBAR : SECTION_NAVIGATION_MODES.HEADER);
    onClick?.();
  };

  return (
    <MenuItem onClick={handleClick}>
      <ListItemIcon>{isSwitchingToSidebar ? <ManageSearchIcon /> : <TabIcon />}</ListItemIcon>
      <ListItemText
        primary={isSwitchingToSidebar ? 'Use section sidebar' : 'Use section tabs'}
        secondary={isSwitchingToSidebar ? 'Show Find a section' : 'Hide Find a section'}
      />
    </MenuItem>
  );
}
